import { Svg, type Props as SvgProps } from './Svg'

export const IconInfo = (props: SvgProps) => (
	<Svg {...props} viewBox='0 0 24 24' fill='currentcolor' xmlns='http://www.w3.org/2000/svg'>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M12 4C7.58879 4 4 7.58879 4 12C4 16.4112 7.58879 20 12 20C16.4112 20 20 16.4112 20 12C20 7.58879 16.4112 4 12 4ZM12 2C17.5229 2 22 6.47715 22 12C22 17.5228 17.5229 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 8C11.4477 8 11 7.55228 11 7C11 6.44771 11.4477 6 12 6C12.5523 6 13 6.44771 13 7C13 7.55228 12.5523 8 12 8ZM11.9995 17.4687C11.4472 17.4687 10.9995 17.021 10.9995 16.4687V10.4687C10.9995 9.91646 11.4472 9.46875 11.9995 9.46875C12.5518 9.46875 12.9995 9.91646 12.9995 10.4687V16.4687C12.9995 17.021 12.5518 17.4687 11.9995 17.4687Z'
		/>
	</Svg>
)
